import { ref, computed } from 'vue'

//���i���X�g��n���Ă��炤
export default function ( accountList ){
  
  //�����������錾�Aref�Ƃ��Đ錾
  const searchAccountId = ref('')
  const searchAccountName = ref('')
  const searchCompanyName = ref('')
  
  //searchQuery�ύX���ɏ�ɓ��Y���W�b�N���N���AVue.js��computed�@�\���g�p����
  //�����ōi��ꂽ�l���i�[����ϐ���return�Ő錾���O���Ŏg�p���鎖���o����
  const matchAccount = computed(() => {
    return accountList.value.filter(account => {
      
      if( searchAccountId.value != "" && !account.userid.includes(searchAccountId.value) ){
        return false
      }
      if(searchAccountName.value != "" && !account.name.includes( searchAccountName.value )){
        return false
      }

      if(searchCompanyName.value != "" && !account.companyname.includes( searchCompanyName.value )){
        return false
      }

      return true
    })
  })

  //���Y���C�u�������񋟂���ϐ��A���\�b�h��錾
  return{
    searchAccountId,
    searchAccountName,
    searchCompanyName,
    matchAccount
  }

}